<template>
  <v-container grid-list-xs fluid background pa-4>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12  v-if="permission_edit == true || admin == 'true'">
        <v-tooltip top>
          <v-btn
            slot="activator"
            color="primary"
            dark
            fixed
            bottom
            right
            fab
            @click="onHandleDialog(true, 'create', null)"
          >
            <v-icon>fa-plus</v-icon>
          </v-btn>
          <span>{{$t('create')}}</span>
        </v-tooltip>
      </v-flex>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex md12 sm12 xs12 v-for="(item, index) in group_access" :key="index" @click="''">
            <v-card class="coco-box-shadow">
              <v-layout align-center justify-center row wrap class="coco-list-layout">
                <v-flex lg8 md6 sm6 xs12 pa-3>
                  <v-layout row wrap>
                    <v-flex lg6 md6 sm12 xs12>
                      <span>{{$t('group_number')}} : {{item.group_code}}</span>
                    </v-flex>
                    <v-flex lg6 md6 sm12 xs12>
                      <span>{{$t('groupname')}} : {{item.group_name}}</span>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex lg4 md6 sm6 xs12 pa-3>
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap class="hidden-xs-only">
                        <v-flex offset-lg4 offset-md4 offset-sm4 lg2 md2 sm2 xs6 v-if="permission_view== true || admin == 'true'">
                          <v-tooltip top>
                            <v-btn
                              slot="activator"
                              color="success"
                              icon
                              flat
                              @click="viewdata(item.group_code)"
                            >
                              <v-icon>search</v-icon>
                            </v-btn>
                            <span>{{$t('viewdata')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex lg2 md2 sm2 xs6  v-if="permission_edit == true || admin == 'true'">
                          <v-tooltip top>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="selectemp(item.group_code)"
                            >
                              <v-icon>how_to_reg</v-icon>
                            </v-btn>
                            <span>{{$t('ListnameEmp')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex lg2 md2 sm2 xs6 v-if="permission_edit == true || admin == 'true'">
                          <v-tooltip top>
                            <v-btn
                              slot="activator"
                              color="blue darken-2"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('menu.Permissions')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex lg2 md2 sm2 xs6 v-if="permission_edit == true || admin == 'true'">
                          <v-tooltip top>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                      <v-layout row wrap class="hidden-sm-and-up" >
                        <v-flex lg3 md3 sm3 xs6 pa-1>
                          <v-btn block color="success" @click="viewdata(item.group_code)" style="font-size:0.8em;">
                            <v-icon>search</v-icon>
                            <span >&nbsp;{{$t('viewdata')}}</span>
                          </v-btn>
                        </v-flex>
                        <v-flex lg3 md3 sm3 xs6 pa-1>
                          <v-btn block color="warning" @click="selectemp(item.group_code)" style="font-size:0.8em;">
                            <v-icon>edit</v-icon>
                            <span>&nbsp;{{$t('ListnameEmp')}}</span>
                          </v-btn>
                        </v-flex>
                        <v-flex lg4 md4 sm4 xs6 pa-1>
                          <v-btn
                            block
                            color="blue darken-2"
                            @click="onHandleDialog(true,'update',item)"
                            style="font-size:0.8em;color:#fff;"
                          >
                            <v-icon>done</v-icon>
                            <span>&nbsp;{{$t('menu.Permissions')}}</span>
                          </v-btn>
                        </v-flex>
                        <v-flex lg2 md2 sm2 xs6 pa-1>
                          <v-btn block color="error"  style="font-size:0.8em;color:#fff;" @click="''">
                            <v-icon>delete</v-icon>
                            <span>&nbsp;{{$t('delete')}}</span>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="coco-list-divider" style="margin-top : 10px;">
                  <v-divider />
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDelete"
        />
      </v-flex>
      <!-- FormDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="form_dialog_data" v-on:close-dialog="onCloseFormDialog" />
      </v-flex>
      <!-- Snackbar -->
     <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
    </v-layout>

    <!-- view Dialog -->
    <v-layout row justify-center>
      <v-dialog
        v-model="viewdialog"
        fullscreen
        transition="dialog-bottom-transition"
        :overlay="false"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-tooltip bottom>
              <v-btn slot="activator" icon dark @click="viewdialog =false">
                <v-icon>close</v-icon>
              </v-btn>
              <span>{{ $t('close') }}</span>
            </v-tooltip>
            <v-toolbar-title>
              <span>{{ $t('viewdata')}}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat dark @click="onSave()">
              <v-icon>save</v-icon>
              <span class="px-2">{{ $t('save') }}</span>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid pa-1 pt-3>
              <v-layout wrap>
                <v-flex lg6 md6 sm6 xs12 pa-2>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-toolbar-title>
                        <span>{{ $t('EmployeeINGroup')}}</span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text style="max-height:70vh;height:500px !important;overflow: auto;">
                      <v-layout wrap>
                        <v-flex xs12 style="margin-top:10px" v-if="size > 0">
                          <v-layout
                            wrap
                            v-for="(permission, i) in view_group.employees"
                            :key="i"
                            @click="''"
                          >
                            <v-flex lg12 md12 sm12 xs12 style="margin-top:10px">
                              <span
                                style="margin-left:20px;margin-top:20px"
                              >{{permission.emp_code}} : {{permission.first_name}} {{permission.last_name}}</span>
                            </v-flex>
                            <v-flex xs12 class="coco-list-divider" style="margin-top : 10px;">
                              <v-divider />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 style="margin-top:10px" v-if="size == 0">
                          <v-layout wrap>
                            <v-flex lg6 md6 sm6 xs12>
                              <span style="margin-left:20px;margin-top:20px">ไม่มีพนักงานในกลุ่มนี้</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>

                <v-flex lg6 md6 sm6 xs12 pa-2>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-toolbar-title>
                        <span>{{ $t('Permissions')}}</span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text style="max-height:70vh;height:500px !important;overflow: auto;">
                      <v-layout wrap v-for="(item, index) in group" :key="index" @click="''" ml-3>
                        <v-flex xs12 style="margin-top:10px">
                          <span>
                            <h4>{{$t("menu."+item.group_name)}}</h4>
                          </span>
                          <v-layout
                            row
                            wrap
                            v-for="(permission, i) in view_group.permission"
                            :key="i"
                            @click="''"
                          >
                            <v-flex
                              lg6
                              md6
                              sm6
                              xs12
                              pa-3
                              v-if="permission.group == item.group_name"
                            >
                              <span
                                style="margin-left:20px;margin-top:20px"
                              >{{$t("menu."+permission.module_name)}}</span>
                            </v-flex>
                            <v-flex lg6 md6 sm6 xs12 v-if="permission.group == item.group_name">
                              <v-chip
                                v-if="permission.edit==true && permission.reads==true"
                                style="margin-left:20px;float:right"
                                class="ma-2"
                                color="green"
                                text-color="white"
                              >
                                <v-icon left>done</v-icon>
                                {{$t('editandread')}}
                              </v-chip>
                              <v-chip
                                v-if="permission.edit==true && permission.reads==false"
                                style="margin-left:20px;float:right"
                                class="ma-2"
                                color="warning"
                                text-color="white"
                              >
                                <v-icon left>edit</v-icon>
                                {{$t('editonly')}}
                              </v-chip>
                              <v-chip
                                v-if="permission.edit==false && permission.reads==true"
                                style="margin-left:20px;float:right"
                                class="ma-2"
                                color="indigo"
                                text-color="white"
                              >
                                <v-icon left>search</v-icon>
                                {{$t('readsonly')}}
                              </v-chip>
                              <v-chip
                                v-if="permission.edit==false && permission.reads==false"
                                style="margin-left:20px;float:right"
                                class="ma-2"
                                color="error"
                                text-color="white"
                              >
                                <v-icon left>not_interested</v-icon>
                                {{$t('noteditandread')}}
                              </v-chip>
                            </v-flex>
                            
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 class="coco-list-divider" style="margin-top : 10px;">
                          <v-divider />
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- Employee Dialog -->
    <v-layout row justify-center>
      <v-dialog
        v-model="empdialog"
        fullscreen
        transition="dialog-bottom-transition"
        :overlay="false"
      >
        <v-card>
          <v-toolbar dark color="primary">
            <v-tooltip bottom>
              <v-btn slot="activator" icon dark @click="closeEmp()">
                <v-icon>close</v-icon>
              </v-btn>
              <span>{{ $t('close') }}</span>
            </v-tooltip>
            <v-toolbar-title>
              <span>{{ $t('ADD_Employee')}}</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat dark @click="onSave()">
              <v-icon>save</v-icon>
              <span class="px-2">{{ $t('save') }}</span>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-container fluid pa-1 pt-3>
              <v-layout wrap>
                <v-flex lg4 md4 sm4 xs6>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-toolbar-title>
                        <span>{{ $t('EmployeeINGroup')}}</span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text style="max-height:70vh;height:500px !important;overflow: auto;">
                      <v-layout wrap>
                        <v-flex xs12 style="margin-top:10px" >
                          <v-layout
                            wrap
                            v-for="(emp, i) in emp_in_group"
                            :key="i"
                            @click="''"
                            ml-2
                          >
                            <v-flex xs12 style="margin-top:5px">
                              <v-checkbox :label="`${emp.emp_code} : ${emp.first_name} ${emp.last_name}`" v-model="emp.isChecked" 
                              ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 class="coco-list-divider" style="margin-top : 5px;">
                              <v-divider />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <!-- <v-flex xs12 style="margin-top:5px" v-if="size == 0">
                          <v-layout wrap>
                            <v-flex lg6 md6 sm6 xs12>
                              <span style="margin-left:20px;margin-top:20px">ไม่มีพนักงานในกลุ่มนี้</span>
                            </v-flex>
                          </v-layout>
                        </v-flex> -->
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex offset-lg1 lg2>
                  <v-btn depressed block color="success" @click="addEmp" :disabled="this.emp_not_group.length == 0">
                    <v-icon>fast_rewind</v-icon>
                    <span>ADD</span>
                  </v-btn>
                  <br />
                  <br />
                  <br />
                  <v-btn depressed block color="error" @click="removeEmp" :disabled="this.emp_in_group.length == 0">
                    <span>REMOVE</span>
                    <v-icon>fast_forward</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex offset-lg1 lg4>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-toolbar-title>
                        <span>{{ $t('ListEmployeeGroup')}}</span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text style="max-height:70vh;height:500px !important;overflow: auto;">
                      <v-layout wrap>
                        <v-flex xs12 style="margin-top:5px">
                          <v-layout wrap v-for="(emp, i) in emp_not_group" :key="i" @click="''" ml-2>
                            <v-flex xs12 style="margin-top:5px">
                              <v-checkbox
                                :label="`${emp.emp_code} : ${emp.first_name} ${emp.last_name}`"
                                 v-model="emp.isChecked"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex xs12 class="coco-list-divider" style="margin-top : 5px;">
                              <v-divider />
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
           <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn color="success" @click="onsaveEmp()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ $t('save') }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import EmployeeService from "@/services/EmployeeService";
import FrmDialog from "./FormDialog.vue";
import Empimage from "../../components/getempimage.vue";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Utils from "@/utils/";
import UserService from "@/services/UserService";
export default {
  data: () => ({
    empdialog: false,
    viewdialog: false,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    delete_dialog_data: {
      status: false
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    table_data: [],
    pageActive: 1,
    processing: false,
    canLoadMore: true,
    group: [],
    group_access: [],
    view_group: {},
    emp_in_group: [],
    emp_not_group: [],
    add_arr:[],
    remove_arr:[],
    size: 0,
    savegroup:{},
    selected:[],
    permission_edit:false,
    permission_view:false,
    admin:false,
    empCode: localStorage._empcode,
    permission:[]
  }),
  created: async function() {
    this.admin = localStorage._is_admin;
    await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
    await this.checkpermission("IndividualPermissionsList");
    console.log(this.check_permission)
    // this.setShowFilter({
    //   status: 0
    // });
    // this.commitSetToolbar({
    //   patternTool: "1"
    // });
    this.getGroup();

    this.$store.watch(
      state => {
        state.filter.SelectBranch;
        state.filter.SelectDepartment;
        state.filter.SelectPosition;
        state.filter.SearchData;
        state.filter.FromDate;
        state.filter.ToDate;
      },
      () => {
        this.pageActive = 1;
        this.table_data = [];
        this.canLoadMore = true;
        // this.getExpensesList();
      },
      {
        deep: true
      }
    );
  },
  destroyed: function() {
    this.commitToggleAlertDialog({
      status: false,
      message: Object
    });
  },
  components: {
    FrmDialog,
    Empimage,
    DeleteDialog
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate"
    ]),
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols"
    ]),
     //...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    viewdata(group_code) {
      console.log(group_code);
      EmployeeService.getUserPermissionbyGroup(group_code).then(res => {
        console.log(res.data);
        this.viewdialog = true;
        this.view_group = res.data;
        this.size = this.view_group.employees.length;
        this.checkgroup();
      });
      console.log(group_code);
    },
    selectemp(group_code) {
      console.log(group_code);
      EmployeeService.getUserPermissionbyGroup(group_code).then(res => {
        console.log("fffff",res.data);
        this.savegroup = res.data;
        this.empdialog = true;
        this.emp_in_group = res.data.employees;
        this.size = this.emp_in_group.length;
         res.data.outsider.forEach(element => {
        this.emp_not_group = res.data.outsider
          // this.emp_not_group.push({
          //   emp_code:element.emp_code,
          //   first_name:element.first_name,
          //   last_name: element.last_name,
          //   nick_name: element.nick_name,
          //   isChecked:false
          // })
        });
      });
      // EmployeeService.findEmpPermission().then(res => {
      //   console.log(res.data.content);
      //   this.empdialog = true;
      //   res.data.content.forEach(element => {
      //     this.emp_not_group.push({
      //       code:element.code,
      //       first_name:element.first_name,
      //       last_name: element.last_name,
      //       isChecked:false
      //     })
      //   });
        // this.emp_not_group = res.data.content;
      //});
    },
    s_emp(code){
      this.selected.push(code);
      console.log("dddd",code);
    },
     checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    getGroup() {
      EmployeeService.getGroupPermission()
        .then(res => {
          console.log(res.data);
          this.group_access = res.data;
        })
        .catch(err => {
          console.log(err.message);
        });
    },
    deleteItem(data) {
      this.delete_dialog_data.status = true;
      let message =
        "<p>" +
        this.$t("question.delete") +
        `<br>` +
        this.$t("groupname") +
        " : " +
        data.group_name +
        `<br>` +
        this.$t("group_number") +
        " : " +
        data.group_code +
        " ?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.group_code = data.group_code;
    },
    onDelete() {
      console.log(this.delete_dialog_data.group_code);
      EmployeeService.deleteGroup(this.delete_dialog_data.group_code)
        .then(res => {
          this.showSnackBar(this.$t("message.delete"), "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getGroup();
          this.delete_dialog_data.status = false;
        })
        .catch(err => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data
          });
        });
    },
    checkgroup() {
      this.group = [];
      var groupname = "";
      for (let index = 0; index < this.view_group.permission.length; index++) {
        if (this.view_group.permission[index].group != groupname) {
          groupname = this.view_group.permission[index].group;
          //console.log(groupname);
          this.group.push({ group_name: groupname });
        } else {
          groupname = groupname;
        }
      }
    },
    addEmp() {
      var sum = 0;
    this.remove_arr =[];
    this.add_arr = this.emp_in_group
     this.emp_not_group.forEach(element => {
       if(element.isChecked){
          sum ++;
          this.add_arr.push({
            emp_code: element.emp_code,
            first_name:element.first_name,
            last_name: element.last_name,
            nick_name: element.nick_name
          });
          // this.emp_in_group = this.add_arr;
       }
       else if(!element.isChecked){
         
         this.remove_arr.push({
            emp_code: element.emp_code,
            first_name:element.first_name,
            last_name: element.last_name,
            nick_name: element.nick_name
          });
           //this.emp_not_group = this.remove_arr;
       }
     }); 
   
         this.emp_in_group = this.add_arr; 
         this.emp_not_group = this.remove_arr;
     if(this.remove_arr.length == 0){
          this.emp_not_group =[];
       }
    if(sum == 0){
          this.showSnackBar("เลือกพนักงานก่อนเพิ่มเข้ากลุ่ม", "error");
         
         this.emp_in_group = this.emp_in_group; 
    }
    
    console.log(this.add_arr)
    console.log("remove:",this.remove_arr)
    },
    removeEmp() {
     var mins = 0;
     this.add_arr = []; 
     this.remove_arr = this.emp_not_group;
     console.log(this.remove_arr)
     this.emp_in_group.forEach(element => {
       console.log(element.isChecked)
       if(element.isChecked ){
         mins++;
          this.remove_arr.push({
            emp_code: element.emp_code,
            first_name:element.first_name,
            last_name: element.last_name,
            nick_name: element.nick_name
          });
        
       }
       else{
         this.add_arr.push({
            emp_code: element.emp_code,
            first_name:element.first_name,
            last_name: element.last_name,
            nick_name: element.nick_name
          });
            
       }
     });
       this.emp_not_group = this.remove_arr;
       this.emp_in_group = this.add_arr;

        if(this.remove_arr.length == 0){
          this.emp_not_group =[];
       }
    if(mins == 0){
       this.showSnackBar("เลือกพนักงานก่อนนำออกกลุ่ม", "error");
          this.emp_not_group =  this.emp_not_group ;
    }
    console.log(this.add_arr)
    },
    closeEmp(){
      this.emp_in_group =[];
      this.emp_not_group =[];
      this.add_arr=[];
      this.remove_arr=[];
      this.empdialog =false;
    },
    onsaveEmp(){
       this.savegroup.employees = this.add_arr;
      this.savegroup.outsider = this.remove_arr;
     console.log(this.savegroup);
     EmployeeService.CreateEmpGroupPermission(this.savegroup)
     .then(res=>{
         this.showSnackBar('save success', 'success');
     })
    },
    onCloseFormDialog() {
      this.form_dialog_data.status = false;
      this.getGroup();
      //this.getExpensesList("Form");
    },
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.form_dialog_data.status = false;
      //this.getExpensesList();
    },
    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    onHandleDialog(status, save_type, data) {
      this.form_dialog_data = {
        status: status,
        save_type: save_type,
        data: data
      };
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          this.getExpensesList();
        }
      }
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    }
  }
};
</script>
